"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPanel = void 0;
var settings_panel_component_1 = require("./settings-panel.component");
Object.defineProperty(exports, "SettingsPanel", { enumerable: true, get: function () { return settings_panel_component_1.SettingsPanel; } });
